import { useContext } from 'react';
import { Grid, Table, TableBody, TableCell, TableFooter, TableHead, TableRow, Typography, Tooltip, Zoom } from '@material-ui/core';
import Moment from 'react-moment';
import { DeleteIconButton } from 'components';
import NewOrder from './NewOrder';
import { resolutionsContext } from './ResolutionsContext';
import { ErrorOutline } from '@material-ui/icons';


interface IProps {
    isReadOnly: boolean
}

let ServiceOrders = (props: IProps) => {
    let service = useContext(resolutionsContext);


    return (
        <Grid item xs={12}>
            <Grid container>
                <Grid item xs style={{ backgroundColor: '#efefef' }}>
                    <Typography variant="h5">Service orders</Typography>
                </Grid>
            </Grid>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>M3 Order Number</TableCell>
                        <TableCell>Assignment Number</TableCell>
                        <TableCell>M3 Status</TableCell>
                        <TableCell>Added in Claims by</TableCell>
                        {props.isReadOnly === false &&
                            <TableCell align="right">
                                <NewOrder type="Service" />
                            </TableCell>
                        }
                    </TableRow>
                </TableHead>
                <TableBody>
                    {service.serviceOrders.map(order =>
                        <TableRow key={order.id}>
                            <TableCell>{order.m3OrderNumber}</TableCell>
                            <TableCell>{order.assignmentNumber}</TableCell>
                            <TableCell>
                                {order.m3StatusCode && <>{order.m3StatusCode}&nbsp;{order.m3StatusDescription}</>}
                                {order.errorMessage &&
                                    <Tooltip title={order.errorMessage} TransitionComponent={Zoom}>
                                        <ErrorOutline color="error" />
                                    </Tooltip>
                                }
                            </TableCell>
                            <TableCell>
                                {order.createdBy}&#44;&nbsp;<Moment date={order.createdOn} format="ll" />
                            </TableCell>
                            {props.isReadOnly === false &&
                                <TableCell style={{ whiteSpace: 'nowrap' }} align="right">
                                    <DeleteIconButton
                                        onClick={async () => {
                                            await service.deleteTicketOrder("Service", order.id)
                                        }}
                                    />
                                </TableCell>
                            }
                        </TableRow>
                    )}
                </TableBody>
                {service.serviceOrders.length === 0 &&
                    <TableFooter>
                        <TableRow>
                            <TableCell colSpan={props.isReadOnly === false ? 5 : 4}><i>No service orders found</i></TableCell>
                        </TableRow>
                    </TableFooter>
                }
            </Table>
        </Grid >
    )
}

export default ServiceOrders;